import type { HierarchyType } from "src/common/service/nexus/utils/hierarchy.js";
import { invariant } from "../../../common/utils/invariant.js";
import { useLocation } from "react-router";
import {
	useLoadedCompanyHierarchy,
	useLoadedLegalEntity,
} from "src/routes/routeDataHooks.js";
import { QUERY_PARAM_GROUP } from "src/features/legalEntities/constants.js";

export const useCurrentHierarchyMode = () => {
	const legalEntity = useLoadedLegalEntity();
	const { hierarchy } = useLoadedCompanyHierarchy();
	const { search } = useLocation();
	const searchParams = new URLSearchParams(search);

	// WHY: nexus returns no hierarchy when the user may not see its root, so ?group falls back to the entity.
	const groupRoot = searchParams.has(QUERY_PARAM_GROUP) ? hierarchy : null;

	const parentLegalEntityId = groupRoot
		? groupRoot.legalEntity.id
		: legalEntity.id;

	invariant(parentLegalEntityId);

	const hierarchyType: HierarchyType = groupRoot ? "group" : "legalEntity";

	return { parentLegalEntityId, hierarchyType };
};
